<template>
  <div v-if="visible">
    <el-dialog
      fullscreen
      :visible.sync="visible"
      width="70%"
      center
    >
      <b-row>
        <b-col />
        <b-col
          md="6"
          sm="12"
        >
          <h1 class="description text-center font-weight-bold c-blue">
            {{ convocatoria.nombre }}
          </h1>
        </b-col>
        <b-col />
        <b-col
          class="mt-5"
          cols="12"
        >
          <div class="mx-5">
            <p class="text-26 font-weight-bold c-blue">
              Requisitos
            </p>
            <!-- eslint-disable vue/no-v-html -->
            <h5
              class="m-4 text-1 description mb-0"
              v-html="requireds"
            />
          </div>
        </b-col>
        <b-col
          v-if="convocatoria.documentos_digitales"
          cols="12"
          class="mt-5"
        >
          <div class="mx-5">
            <p class="text-26 font-weight-bold c-blue">
              Documentos
            </p>
            <h4 class="ml-4">
              <strong>Instrucciones:</strong>
            </h4>
            <p class="ml-4 mt-3 text-15">
              <strong>1)</strong> Se deberá adjuntar la siguiente documentación
              en formato electrónico <strong>(escaneado/PDF)</strong>Tamaño
              Máximo 5MB. <strong>NO ESCANEOS CON CELULAR O TABLETA.</strong>
            </p>

            <p class="ml-4 mt-3 text-15">
              <strong>2)</strong> Los archivos deberán ser nombrados con tu CURP
              y el TIPO de archivo al que corresponde separados por un guión
              medio (ejemplo: MEAD881020HMCNGL08_CVU)
            </p>
            <p class="ml-4 mt-3 text-15">
              <strong>3)</strong> Los documentos que adjuntan un formato se debera
              <strong>
                DESCARGAR, REALIZAR EL LLENADO A COMPUTADORA, IMPRIMIR, FIRMAR Y
                ESCANEAR EN FORMATO PDF.</strong>
            </p>
          </div>
          <b-row
            v-if="documentos.length > 0"
            class="mx-5 icons-container text-center"
          >
            <documento
              v-for="(item, index) in documentos"
              :key="index"
              :index="index + 1"
              :documento="item.documento"
            />
          </b-row>
        </b-col>
      </b-row>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <b-row>
          <b-col />
          <b-col>
            <b-button
              variant="success"
              size="lg"
              class="mt-3"
              @click="$emit('hidden', false)"
            >Ver menos</b-button>
            <b-button
              variant="primary"
              :disabled="!convocatoria.register"
              class="ml-2 btn-card mt-3"
              size="lg"
              @click="
                $router.push({
                  name: 'registro',
                  params: {
                    id: convocatoria.id,
                    name: convocatoria.nombre,
                    datosEmpleado: convocatoria.datos_empleado,
                    convocatoria: convocatoria
                  },
                })
              "
            >
              Regístrate
            </b-button>
            <b-button
              variant="secondary"
              class="ml-2 btn-card mt-3"
              size="lg"
              @click="showConvocatoria"
            >
              Ver convocatoria
            </b-button>
          </b-col>
          <b-col />
        </b-row>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { BButton, BCol, BRow } from 'bootstrap-vue'
import Documento from './Documento.vue'

export default {
  components: {
    BButton,
    BCol,
    BRow,
    Documento,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    convocatoria: {
      type: Object,
      required: true,
    },
    documentos: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      requireds: '',
    }
  },
  mounted() {
    const [a, b] = this.convocatoria.requisitos.split('===')
    this.requireds = a + b
    this.visible = false
  },
  methods: {
    showConvocatoria() {
      const url = this.convocatoria.documento !== null ? this.convocatoria.documento : ''
      window.open(url, '_target')
    },
  },
}
</script>

<style scope>
.description {
  word-break: normal;
}
</style>
